import React, { useEffect, useState } from 'react'
import './SetSeriesPriority.css'
import { useDispatch, useSelector } from 'react-redux';
import { seriesList } from '../../features/series/seriesSlice';
import { seriesWithPriorityData } from '../../features/seriesWithPriority/seriesWithPrioritySlice';
const SetSeriesPriority = () => {

    const dispatch = useDispatch();
    const data = useSelector
    ((state) => state.series.data);
    const pending = useSelector((state) => state.series.pending);
    const error = useSelector((state) => state.series.error);
    const finalData = data.data;


    const [updatedSeriesList, setupdatedSeriesList]= useState({
      'newList' : []
    })

    const [firstRender, setfirstRender] = useState(false)


    useEffect(() => {
    const userAgent = navigator.userAgent  || window.opera;

    // Check if the user is on a mobile device
    if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
      // Replace 'your-app-scheme://' with your actual app's custom URL scheme
      const appScheme = 'myapp://cricway.live';

      // Attempt to open the app using the custom URL scheme
      window.location.href = appScheme;

      // Set a timeout to show the download popup if the app is not opened
      setTimeout(() => {
        // Replace 'your-ios-app-id' with your actual iOS app ID
        const iOSAppId = 'com.cricway.app';
        const appStoreUrl = `https://apps.apple.com/app/id${iOSAppId}`;

        // Replace 'your-android-package-name' with your actual Android package name
        const androidPackageName = 'com.cricway.app';
        const playStoreUrl = `https://play.google.com/store/apps/details?id=${androidPackageName}`;

        const userChoice = window.confirm(
          'Would you like to download our mobile app for a better experience?'
        );

        if (userChoice) {
          // Redirect to App Store for iOS
          if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
            window.location.href = appStoreUrl;
          }
          // Redirect to Google Play Store for Android
          else if (/android/g.test(navigator.userAgent)) {
            window.location.href = playStoreUrl;
          }
        }
      }, 2000); // Adjust the timeout duration as needed
    }
  }, []);

    
  // useEffect(() => {
  
  //     const userAgent = navigator.userAgent || window.opera;
  
  //   // Check if the user is on a mobile device
  //   if (!firstRender && /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
  //     // Replace 'myAppPackageName' with your actual Android package name
  //     const androidPackageName = 'com.cricway.app';
  //     // Replace 'com.cricway.app' with your actual iOS app ID
  //     const iOSAppId = 'com.cricway.app';
  
  //     // Replace 'myAppPAckage://' with your actual app's custom URL scheme
  //     const appScheme = 'myapp://cricway.live';
  
  //     // Attempt to open the app using the custom URL scheme
  //     const appOpenTimeout = setTimeout(() => {
  //       // Redirect to the app store if the app doesn't open within a certain time
  //       const userChoice = window.confirm('Would you like to download our mobile app for a better experience?');
  
  //       if (userChoice) {
  //         // Redirect to App Store for iOS
  //         if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
  //           window.location.href = `https://apps.apple.com/app/id${iOSAppId}`;
  //         }
  //         // Redirect to Google Play Store for Android
  //         else if (/android/g.test(navigator.userAgent)) {
  //           window.location.href = `https://play.google.com/store/apps/details?id=${androidPackageName}`;
  //         }
  //       }
  //     }, 2000); // Adjust the timeout duration as needed
  
  //     window.location.href = appScheme;
  
  //     // Clear the timeout if the app opens successfully
  //     window.addEventListener('pagehide', () => {
  //       clearTimeout(appOpenTimeout);

  //     });
  //     setfirstRender(true);
  //   }

   
    
    
  // }, [firstRender]);

    useEffect(() =>{
        // AOS.init({duration : 2000})

        
          dispatch(seriesList());
       
      },[dispatch])

      useEffect(() =>{
       
        setupdatedSeriesList(prevData =>({...prevData, newList : finalData}));
    
    
      },[finalData])
      // useEffect(()=>{
      //   console.log(updatedSeriesList)
      // },[updatedSeriesList])
      


      const handleChange=(priority, id)=>{
       console.log(priority, id)
        setupdatedSeriesList(prevState =>({
            ...prevState, 
             newList : prevState.newList.map(item =>
              item.id === id ? { ...item, priority: priority } : item
            )
          }));
          
      }

      const handleSubmit=()=>{
        
        dispatch(seriesWithPriorityData(updatedSeriesList))
        .then((result) => {
         
          if(result?.payload?.response?.status=== 404){
            alert(result?.payload?.response?.data?.msg);
          }else if(result?.meta?.requestStatus === "fulfilled"){
           
            alert('Priorities are set successfully')
              window.location.reload()
          }
          // console.log('Form submitted successfully!', result);
        
          // Handle the result as needed
        })
        .catch((error) => {
          
          console.error('Form submission failed:', error.message);
          // Handle the error as needed
        });
      }
      
      return (
    <div className='setSeriesPriority'>
        <div className="setSeriesPriorityWrapper">
            <h3 className="setSeriesPriorityHeading">
                Set Series Priority
            </h3>
            <div className="setSeriesPriorityTableWrapper">

            

            <table className="setSeriesPriorityTable">
                <tr>
                    <th>S.no.</th>
                    <th>Series Name</th>
                    <th>Date</th>
                    <th>Priority</th>
                    
                </tr>

                {updatedSeriesList?.newList &&
              updatedSeriesList?.newList?.map((item, index) => (

                <tr key={index}>
                        <td className='seriealNumber'>{`${index+1}`}</td>
                        
                        <td className='productName'>{item?.series}</td>
                        <td className='seriesDate'>{item.series_date}</td>
                        <td className='priorityInput'><input type="text" value = {item.priority}  onChange={(e)=>handleChange(e.target.value, item.id)}/></td>
                
                    </tr>
                
              ))
              }
            </table>

            <div className="submitSeriesPriorities" onClick={()=>handleSubmit()}>Submit</div>
            </div>
        </div>
      
    </div>
  )
}

export default SetSeriesPriority
